import { useQuery } from '@tanstack/react-query';

import { fetchData } from '..';

export const GET_CATEGORIES = 'api/product-master/get-product-categories';

export const getCategoriesQueryKey = ['categories'];

// TODO: make this exhaustive
export type ProductCategory = {
  MasterCategory: string;
  ProductCategory: string;
  ProductCategoryId: number;
};

export function useCategoriesQuery() {
  return useQuery({
    queryKey: getCategoriesQueryKey,
    queryFn: () => fetchData<ProductCategory[]>(GET_CATEGORIES),
  });
}
